import { defaultTheme } from "@cobee/cobee-ui";

const styles = {
  emailMessageText: {
    width: "375px",
    color: defaultTheme.palette.grey[900],
  },
};

export default styles;
